import Logo from '../Logo'
import { Box, IconButton, SwipeableDrawer } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu'
import BtnBox from './BtnBox';
import MainMenu from '../MainMenu';
import SearchBox from '../SearchBox';
import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom';
import SocialLinks from '../SideBar/SocialLinks';

const TopBar = ({ isMobile }) => {

    const [drawerOpen, setDrawerOpen] = useState(false)
    const location = useLocation()
    const closeDrawer = () => setDrawerOpen(false)

    useEffect(() => {
        setDrawerOpen(false)
    }, [location.pathname])

    const handleDrawer = () => {
        setDrawerOpen((prev) => !prev)
    }



    return (
        <Box
            display="flex"
            flexDirection="column"
            gap={2}
            position={isMobile ? 'sticky' : 'relative'}
            top={isMobile ? 0 : 'auto'}
            backgroundColor={isMobile ? 'background.default' : 'transparent'}
            zIndex={isMobile ? 1000 : 'auto'}
            p={isMobile ? 2 : 0}
        >
            <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                gap={2}
            >
                {
                    isMobile && (
                        <Box
                            display="flex"
                            alignItems="center"
                            gap={1}
                        >
                            <IconButton onClick={handleDrawer}>
                                <MenuIcon />
                            </IconButton>
                            <Logo isMobile={isMobile} />
                            <SwipeableDrawer
                                anchor="bottom"
                                open={drawerOpen}
                                onClose={closeDrawer}
                                onOpen={handleDrawer}
                                PaperProps={{ style: { width: '100%', bgcolor: 'background.default', backgroundImage: 'none' } }}
                            >
                                <MainMenu isMobile={isMobile} />
                                <SocialLinks isMobile={isMobile}/>
                            </SwipeableDrawer>

                        </Box>

                    )
                }

                {
                    !isMobile && (
                        <SearchBox isMobile={isMobile} />
                    )
                }

                <BtnBox isMobile={isMobile} />
            </Box>

            {
                isMobile && (
                    <SearchBox isMobile={isMobile} />
                )
            }


        </Box>
    );
};

export default TopBar;